import React, { useState, useEffect, useRef, act } from 'react'
import Api from '../../../../_helpers/Api'
import { useParams, useHistory } from 'react-router-dom'
import { useAuthDataContext } from '../../../../_providers/Auth'
import { trans } from '../../../../_providers/Translation'

//images
import loader from '../../../../assets/img/loader.svg'
import { Tab, Tabs } from '@mui/material'
import Pagination from '../../../Pagination'
import moment from 'moment'
import NoDataFound from '@/components/partials/NoDataFound'
import Skeleton from 'react-loading-skeleton'
import ReactTooltip from 'react-tooltip'

function History(props) {
    const auth = useAuthDataContext()
    const params = useParams()

    const [state, setState] = useState({
        loading: true,
        data: null
    })

    const [expandedRepairsTable, setExpandedRepairsTable] = useState([])

    //NEW: За добавяне на нови подтабове
    const [activeTab, setActiveTab] = useState('actions') // 'actions', 'repairs', 'activity'

    // Activity log state
    const [activityLog, setActivityLog] = useState({
        loading: false,
        data: [],
        limit: 20,
        page: 1,
        totalPages: 1,
    })

    // Repairs history
    const [repairsHistory, setRepairsHistory] = useState({
        loading: false,
        data: []
    })

    useEffect(() => {
        Api.get('reservations/history?id=' + params.id)
            .then(res => {
                setState(prev => ({
                    ...prev,
                    data: res.data,
                    loading: false,
                }))
            })

        Api.get('reservations/repairs-history?id=' + params.id)
            .then(res => {
                setRepairsHistory(prev => ({
                    ...prev,
                    data: res.data,
                    loading: false,
                }))
            })
    }, [])

    // Load activity log — accepts explicit page to avoid stale state reads
    const loadActivityLog = (page = 1) => {
        setActivityLog(prev => ({ ...prev, loading: true, page }))

        Api.get(`reservations/activity-log?id=${params.id}&limit=${activityLog.limit}&page=${page}`)
            .then(res => {
                setActivityLog(prev => ({
                    ...prev,
                    loading: false,
                    data: res.data?.items || [],
                    totalPages: res.data?.pages || 1,
                }))
            })
            .catch(() => {
                setActivityLog(prev => ({ ...prev, loading: false, data: [] }))
            })
    }

    // Load activity log when tab changes to activity
    useEffect(() => {
        if (activeTab === 'activity' && activityLog.data.length === 0) {
            loadActivityLog(1)
        }
    }, [activeTab])

    const renderTabContent = () => {
        switch (activeTab) {
            case 'actions':
                return renderActionsHistory()
            case 'repairs':
                return renderRepairsHistory()
            case 'activity':
                return renderActivityLog()
            default:
                return renderActionsHistory()
        }
    }

    const renderActionsHistory = () => (
        <>
            <div className="pannel">
                <h3>
                    {trans('random.creationDate')}
                </h3>
                <div className="table-scroller">
                    <table>
                        <thead>
                            <tr>
                                <th>
                                    {trans('tables.createdBy')}
                                </th>
                                <th>
                                    {trans('tables.date')}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr>
                                <td>
                                    {state.data.created_by
                                        ? `${state.data.created_by.name} ${state.data.created_by.lastname}`
                                        : '-'
                                    }
                                </td>
                                <td>
                                    {state.data.created_date}
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div className="pannel">
                <h3>
                    SMS/Email
                </h3>
                {state.data.sentsmsmails.length === 0
                    ?
                    <div className="alert warning">
                        {trans('messages.noSavedInfo')}
                    </div>
                    :
                    <div className="table-scroller">
                        <table>
                            <thead>
                                <tr>
                                    <th>
                                        {trans('tables.to')}
                                    </th>
                                    <th>
                                        {trans('tables.topic')}
                                    </th>
                                    <th>
                                        {trans('tables.date')}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {state.data.sentsmsmails.map(r =>
                                    <tr key={'ssm-' + r.id}>
                                        <td>
                                            {r.to}
                                        </td>
                                        <td>
                                            {r.subject}
                                        </td>
                                        <td>
                                            {r.date}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                }
            </div>

            <div className="pannel">
                <h3>
                    {trans('random.sentInvoices')}
                </h3>
                {state.data.sentinvoices.length === 0
                    ?
                    <div className="alert warning">
                        {trans('messages.noSavedInfo')}
                    </div>
                    :
                    <div className="table-scroller">
                        <table>
                            <thead>
                                <tr>
                                    <th style={{ width: '20%' }}>
                                        {trans('tables.to')}
                                    </th>
                                    <th style={{ width: '20%' }}>
                                        {trans('tables.topic')}
                                    </th>
                                    <th style={{ width: '20%' }}>
                                        {trans('tables.info')}
                                    </th>
                                    <th style={{ width: '20%' }}>
                                        {trans('tables.employee')}
                                    </th>
                                    <th style={{ width: '20%' }}>
                                        {trans('tables.date')}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {state.data.sentinvoices.map(r =>
                                    <tr key={'si-' + r.id}>
                                        <td style={{ width: '20%' }}>
                                            {r.to}
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            {r.subject}
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            {r.url
                                                ?
                                                <a href={r.url} target="_blank">
                                                    {r.text}
                                                </a>
                                                :
                                                r.text
                                            }
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            {r.employee
                                                ?
                                                `${r.employee.name} ${r.employee.lastname}`
                                                :
                                                '-'
                                            }
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            {r.date}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                }
            </div>

            <div className="pannel">
                <h3>
                    {trans('random.sentReports')}
                </h3>
                {state.data.sentreports.length === 0
                    ?
                    <div className="alert warning">
                        {trans('messages.noSavedInfo')}
                    </div>
                    :
                    <div className="table-scroller">
                        <table>
                            <thead>
                                <tr>
                                    <th style={{ width: '20%' }}>
                                        {trans('tables.to')}
                                    </th>
                                    <th style={{ width: '20%' }}>
                                        {trans('tables.topic')}
                                    </th>
                                    <th style={{ width: '20%' }}>
                                        {trans('tables.info')}
                                    </th>
                                    <th style={{ width: '20%' }}>
                                        {trans('tables.employee')}
                                    </th>
                                    <th style={{ width: '20%' }}>
                                        {trans('tables.date')}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {state.data.sentreports.map(r =>
                                    <tr key={'sr-' + r.id}>
                                        <td style={{ width: '20%' }}>
                                            {r.to}
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            {r.subject}
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            {r.url
                                                ?
                                                <a href={r.url} target="_blank">
                                                    {r.text}
                                                </a>
                                                :
                                                r.text
                                            }
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            {r.employee
                                                ?
                                                `${r.employee.name} ${r.employee.lastname}`
                                                :
                                                '-'
                                            }
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            {r.date}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                }
            </div>

            <div className="pannel">
                <h3>
                    {trans('random.sentOffers')}
                </h3>
                {state.data.sentquotes.length === 0
                    ?
                    <div className="alert warning">
                        {trans('messages.noSavedInfo')}
                    </div>
                    :
                    <div className="table-scroller">
                        <table>
                            <thead>
                                <tr>
                                    <th style={{ width: '20%' }}>
                                        {trans('tables.to')}
                                    </th>
                                    <th style={{ width: '20%' }}>
                                        {trans('tables.topic')}
                                    </th>
                                    <th style={{ width: '20%' }}>
                                        {trans('tables.info')}
                                    </th>
                                    <th style={{ width: '20%' }}>
                                        {trans('tables.employee')}
                                    </th>
                                    <th style={{ width: '20%' }}>
                                        {trans('tables.date')}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {state.data.sentquotes.map(r =>
                                    <tr key={'sq-' + r.id}>
                                        <td style={{ width: '20%' }}>
                                            {r.to}
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            {r.subject}
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            {r.url
                                                ?
                                                <a href={r.url} target="_blank">
                                                    {r.text}
                                                </a>
                                                :
                                                r.text
                                            }
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            {r.employee
                                                ?
                                                `${r.employee.name} ${r.employee.lastname}`
                                                :
                                                '-'
                                            }
                                        </td>
                                        <td style={{ width: '20%' }}>
                                            {r.date}
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                }
            </div>

            <div className="pannel">
                <h3>
                    {trans('random.employeeReport')}
                </h3>
                {state.data.reports.length === 0
                    ?
                    <div className="alert warning">
                        {trans('messages.noSavedInfo')}
                    </div>
                    :
                    <div className="table-scroller">
                        <table>
                            <thead>
                                <tr>
                                    <th>
                                        {trans('tables.date')}
                                    </th>
                                    <th>
                                        {trans('tables.report')}
                                    </th>
                                    <th>
                                        {trans('tables.employee')}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {state.data.reports.map(r =>
                                    <tr key={'r-' + r.id}>
                                        <td>
                                            {moment(r.updated_at).format('DD.MM.YYYY')}
                                        </td>
                                        <td>
                                            {r.report}
                                        </td>
                                        <td>
                                            {r.employee
                                                ? `${r.employee.name} ${r.employee.lastname}`
                                                : '-'
                                            }
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                }
            </div>

            <div className="pannel">
                <h3>
                    {trans('random.payments')}
                </h3>
                {state.data.payments.length === 0
                    ?
                    <div className="alert warning">
                        {trans('messages.noSavedInfo')}
                    </div>
                    :
                    <div className="table-scroller">
                        <table className="invoices">
                            <thead>
                                <tr>
                                    <th>ID</th>
                                    <th>{trans('tables.type')}</th>
                                    <th>{trans('tables.price')}</th>
                                    <th>{trans('tables.documentNumber')}</th>
                                    <th>{trans('tables.date')}</th>
                                    <th>{trans('tables.paymentMethod')}</th>
                                    <th>{trans('tables.employee')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {state.data.payments.map(i =>
                                    <tr key={'i-' + i.id}>
                                        <td>{i.id}</td>
                                        <td>{i.type}</td>
                                        <td>{i.price_formatted} {i.currency && i.currency.name}</td>
                                        <td>
                                            {i.invoice
                                                ?
                                                <a href={i.invoice.full_url + '&token=' + auth.token()} target="_blank">
                                                    {i.invoice.number}
                                                </a>
                                                :
                                                '-'
                                            }
                                        </td>
                                        <td>{i.created_at_dmy}</td>
                                        <td>
                                            {i.paymentmethod
                                                ?
                                                i.paymentmethod.translation.name
                                                :
                                                ''
                                            }
                                        </td>
                                        <td>
                                            {i.employee
                                                ?
                                                `${i.employee.name} ${i.employee.lastname}`
                                                :
                                                '-'
                                            }
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                    </div>
                }
            </div>

            <div className="pannel">
                <h3>
                    {trans('random.clientSignature')}
                </h3>
                {!state.data.client_signature_url
                    ?
                    <div className="alert warning">
                        {trans('messages.noSavedInfo')}
                    </div>
                    :
                    <div className="table-scroller">
                        <table className="invoices">
                            <thead>
                                <tr>
                                    <th>{trans('tables.client')}</th>
                                    <th>{trans('tables.comment')}</th>
                                    <th className="center">{trans('tables.clientSignature')}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>{state.data.client_name}</td>
                                    <td>{state.data.client_comment}</td>
                                    <td className="center">
                                        <img data-tip data-for={'img-' + state.data.id} src={state.data.client_signature_url} alt="" height={25} />
                                        <ReactTooltip
                                            id={'img-' + state.data.id}
                                            effect="solid"
                                            border={true}
                                            borderColor="#ccc"
                                            backgroundColor="white"
                                            arrowColor="white"
                                        >
                                            <img src={state.data.client_signature_url} alt="" style={{ maxWidth: '300px', maxHeight: '300px' }} />
                                        </ReactTooltip>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                }
            </div>
        </>
    )

    const renderRepairsHistory = () => (
        <>
            <div className="pannel">
                <h3>
                    {trans('headings.repairsHistory')}
                </h3>
                {repairsHistory.loading ?
                    <Skeleton height={45} count={10} />
                    : repairsHistory.data.length === 0 ?
                        <NoDataFound />
                        : <ul className="repairs-history">
                            {repairsHistory.data.map((r, index) =>
                                <li className={expandedRepairsTable.includes(r.appliance_id) ? 'expanded' : ''} onClick={() => setExpandedRepairsTable(prev => prev.includes(r.appliance_id) ? prev.filter(id => id !== r.appliance_id) : [...prev, r.appliance_id])} key={index}>
                                    <p>
                                        {`${r.appliance?.appliancecategory?.name} - ${r.appliance?.appliancebrand?.name}`}
                                    </p>
                                    {expandedRepairsTable.includes(r.appliance_id) ?

                                        <>
                                            <br />
                                            {
                                                r.reports.length ?
                                                    <div className="table-scroller">
                                                        <table>
                                                            <thead>
                                                                <tr>
                                                                    <th>
                                                                        {trans('tables.number')}
                                                                    </th>
                                                                    <th>
                                                                        {trans('tables.date')}
                                                                    </th>
                                                                    <th>
                                                                        {trans('tables.report')}
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {r.reports.map(r =>
                                                                    <tr key={'r-' + r.id}>
                                                                        <td>
                                                                            {r.id}
                                                                        </td>
                                                                        <td>
                                                                            {moment(r.created_at, 'YYYY-MM-DD HH:mm:ss').format('DD.MM.YYYY H:mm')}
                                                                        </td>
                                                                        <td>
                                                                            {r.report}
                                                                        </td>
                                                                    </tr>
                                                                )}
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                    :
                                                    <div
                                                        className="alert warning"
                                                        style={{
                                                            marginBottom: 0,
                                                            width: "100%",
                                                        }}
                                                    >
                                                        {trans("messages.noDataFound")}
                                                    </div>
                                            }
                                        </>

                                        : <>
                                        </>
                                    }
                                </li>
                            )}
                        </ul>
                }
            </div>
        </>
    )

    const renderActivityLog = () => {
        // Flatten: each change becomes its own row
        const rows = []
        activityLog.data.forEach(activity => {
            const userName = activity.user_name || activity.user?.full_name || activity.user?.name || null

            const details = activity.changes?.details

            if (activity.action === 'created' || activity.is_created) {
                rows.push({
                    num: activity.id,
                    date: activity.date,
                    before: activity.action_translation || `Създадена нова резервация ${params.id}`,
                    after: '-',
                    userName,
                })
            } else if (details && details.length > 0) {
                details.forEach((change, ci) => {
                    rows.push({
                        num: activity.id,
                        date: activity.date,
                        before: change.from || '-',
                        after: change.to || '-',
                        userName,
                    })
                })
            } else {
                rows.push({
                    num: activity.id,
                    date: activity.date,
                    before: activity.action_translation || activity.action,
                    after: '-',
                    userName,
                })
            }
        })

        return (
            <>
                <div className="pannel">
                    <h3>{trans('headings.activityLog')}</h3>
                    {activityLog.loading ? (
                        <Skeleton height={45} count={10} />
                    ) : rows.length === 0 ? (
                        <NoDataFound />
                    ) : (
                        <div className="table-scroller">
                            <table>
                                <thead>
                                    <tr>
                                        <th>№</th>
                                        <th>{trans('tables.date')}</th>
                                        <th>{trans('tables.before')}</th>
                                        <th>{trans('tables.after')}</th>
                                        <th style={{ position: 'sticky', right: 0, background: '#fff', zIndex: 1 }}>{trans('labels.user')}</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {rows.map((row, index) => (
                                        <tr key={index}>
                                            <td>{row.num}</td>
                                            <td style={{ whiteSpace: 'nowrap' }}>{row.date}</td>
                                            <td style={{ maxWidth: 300, wordBreak: 'break-word' }}>{row.before}</td>
                                            <td style={{ maxWidth: 300, wordBreak: 'break-word' }}>{row.after}</td>
                                            <td style={{ position: 'sticky', right: 0, background: '#fff', whiteSpace: 'nowrap', boxShadow: '-2px 0 4px rgba(0,0,0,0.06)' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                    <span style={{
                                                        width: 28, height: 28, borderRadius: '50%',
                                                        background: '#e0784e', color: '#fff',
                                                        display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
                                                        fontSize: 12, fontWeight: 600, flexShrink: 0
                                                    }}>
                                                        {row.userName ? row.userName.charAt(0).toUpperCase() : '?'}
                                                    </span>
                                                    {row.userName || '-'}
                                                </div>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}

                    <Pagination
                        pages={activityLog.totalPages}
                        page={activityLog.page}
                        handlePage={p => loadActivityLog(p.selected + 1)}
                    />
                </div>
            </>
        )
    }

    return (
        <div id="reservation-history">
            <div className='pannel'>
                {state.loading ?
                    <img src={loader} alt="loading" />
                    :
                    <>
                        <Tabs value={activeTab} onChange={(e, val) => setActiveTab(val)}>
                            <Tab label={trans('tabs.actionsHistory')} value="actions" />
                            <Tab label={trans('headings.repairsHistory')} value="repairs" />
                            <Tab label={trans('tabs.activityLog')} value="activity" />
                        </Tabs>

                        {/* Tab content */}
                        <div className="tab-content">
                            {renderTabContent()}
                        </div>
                    </>}
            </div>
        </div>
    )
}

export default History